import moment from 'moment';

// Holidays
export const holidays = (autocareHolidays) => {

  let holidays = []
  if (autocareHolidays) {
    autocareHolidays.map( holiday => {
      holidays.push(moment(new Date(holiday)).dayOfYear())
    })
  } else {
    holidays =
      [
        moment(new Date('January 1, 2018 12:00:00')).dayOfYear(),
        moment(new Date('January 6, 2018 12:00:00')).dayOfYear(),
        moment(new Date('February 28, 2018 12:00:00')).dayOfYear(),
        moment(new Date('March 29, 2018 12:00:00')).dayOfYear(),
        moment(new Date('March 30, 2018 12:00:00')).dayOfYear(),
        moment(new Date('April 18, 2018 12:00:00')).dayOfYear(),
        moment(new Date('May 1, 2018 12:00:00')).dayOfYear(),
        moment(new Date('May 31, 2018 12:00:00')).dayOfYear(),
        moment(new Date('August 15, 2018 12:00:00')).dayOfYear(),
        moment(new Date('October 12, 2018 12:00:00')).dayOfYear(),
        moment(new Date('November 1, 2018 12:00:00')).dayOfYear(),
        moment(new Date('December 6, 2018 12:00:00')).dayOfYear(),
        moment(new Date('December 8, 2018 12:00:00')).dayOfYear(),
        moment(new Date('December 25, 2018 12:00:00')).dayOfYear()
      ]
  }

  return holidays
}




// WEBPACK FOOTER //
// ./src/constants/holidays.js